export default "__VITE_ASSET__BNcp21wj__"